// extracted by mini-css-extract-plugin
export var sliderRange = "_ri-2";
export var sliderRoot = "_ri-0";
export var sliderThumb = "_ri-3";
export var sliderTrack = "_ri-1";